import React from "react";
import { TotalRecordsComponent } from "./TotalRecordsComponent";
import { DetailsComponent } from "./DetailsComponent";
import { ReportingFilter } from "./ReportingFilter";
import "./DataHolder.scss";
import { Chart } from "react-google-charts";

export const CovermeReportingDHComponent = ({
    totalRecordsCount,
    completedEncountersCount,
    coveragesCount,
    formattedFacility,
    submitFilter,
    selectedCustomerChanged,
    selectedCustomer,
    exportEncounters,
    lastMonthTotalCount,
    LastMonthCoverageCount,
    lastMonthCompletedEncountersCount,
    last6MonthsTotalAndCompletedRecordsCount,
    lastMonthEncounterswithprogramsCount,
    encounterswithprogramsCount,
    lastMonthEncounterswithCoveragesCount,
    encounterswithCoveragesCount,
    last6MonthsProgramsCount
}) => {
    const options = {
        hAxis: {
        },
        vAxis: {
        },
        series: {
          1: { color: "#30D9D9" },
          0: { color: '#2F5AD8' },
        },
      };
      const options1 = {
        colors: ['#30D8D7', '#2FAFD8', '#2F84D8', '#2F5AD8','#2F30D8','#2F30D8'],
        isStacked: true,
        height: 300,
        legend: { position: "top", maxLines: 6 },
        vAxis: { minValue: 0 },
      };
    return (
        <div>
            <div>
                <div className={"reporting_filter_div_inside_data_holder_component"}>
                    <ReportingFilter formattedFacilities={formattedFacility} 
                        submitFilter={submitFilter}
                        selectedCustomerChanged={selectedCustomerChanged}
                        selectedCustomer ={selectedCustomer}
                        exportEncounters={exportEncounters}/>
                </div>
            </div>

            <div className="total_records_component_details_component_set_top_margin">
                <div className={"box_alignment_total_records_component"}>
                    <TotalRecordsComponent title={totalRecordsCount} subTitle={"Total Cases"} 
                        changeType={lastMonthTotalCount!=0 ?totalRecordsCount -lastMonthTotalCount :0}
                        changeValue={lastMonthTotalCount!=0 ?((Math.abs( totalRecordsCount -lastMonthTotalCount ))/lastMonthTotalCount*100).toFixed(0)+'%':"-"} />
                    <TotalRecordsComponent title={completedEncountersCount} subTitle={"Completed Cases"}
                        changeType={lastMonthCompletedEncountersCount!= 0 ?completedEncountersCount -lastMonthCompletedEncountersCount :0} 
                        changeValue={lastMonthCompletedEncountersCount!= 0 ?((Math.abs(lastMonthCompletedEncountersCount - completedEncountersCount))/lastMonthCompletedEncountersCount*100).toFixed(0)+'%':"-"}  />
                   <TotalRecordsComponent title={encounterswithCoveragesCount} subTitle={"Coverage Found"}
                        changeType={lastMonthEncounterswithCoveragesCount!= 0 ?encounterswithCoveragesCount -lastMonthCompletedEncountersCount :0} 
                        changeValue={lastMonthEncounterswithCoveragesCount!= 0 ?((Math.abs(lastMonthEncounterswithCoveragesCount - encounterswithCoveragesCount))/lastMonthEncounterswithCoveragesCount*100).toFixed(0)+'%':"-"}  />
                   <TotalRecordsComponent title={completedEncountersCount} subTitle={"Programs Selected"}
                        changeType={lastMonthEncounterswithprogramsCount!= 0 ?encounterswithprogramsCount -lastMonthEncounterswithprogramsCount :0} 
                        changeValue={lastMonthEncounterswithprogramsCount!= 0 ?((Math.abs(lastMonthEncounterswithprogramsCount - encounterswithprogramsCount))/lastMonthEncounterswithprogramsCount*100).toFixed(0)+'%':"-"}  />
                </div>
                <div className="box_alignment_details_component_charts">
                    <div style={{border:"solid 1px #B6BED1",width:"47%",marginLeft:"1.6%",height:"460px",padding:"10px",borderRadius:"4px",boxShadow:"5px 5px 5px rgba(0, 0, 0, 0.1)"}}>
                        <h3 style={{textAlign:"center",color:"#51617D",fontSize:"20px",fontWeight:700}}>Cases: Total vs. Completed </h3>
                        
                        <Chart
                            chartType="LineChart"
                            width="100%"
                            height="400px"
                            data={last6MonthsTotalAndCompletedRecordsCount}
                            options={options}
                        />
                    </div>
                    <div style={{border:"solid 1px #B6BED1",width:"47%",marginLeft:"3.1%",height:"460px",padding:"10px",borderRadius:"4px",boxShadow:"5px 5px 5px rgba(0, 0, 0, 0.1)"}}>
                        <h3 style={{marginBottom:"20px",textAlign:"center",color:"#51617D",fontSize:"20px",fontWeight:700}}>Coverage and Programs</h3>

                        <Chart
                            chartType="Bar"
                            width="100%"
                            style={{marginTop:"70px"}}
                            height="400px"
                            data={last6MonthsProgramsCount}
                            options={options1}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};
